var videojs = require('video.js');
var VideoTracker = require('./video-tracker');
var beforeRequest = require('./video-before-request');
var logError = require('./video-error-handler');

require('videojs-contrib-hls');

/**
 * Initialise video.js player.
 *
 * @param {String} videoId
 * @param {Object} options
 * @return {Object}
 */
var init = function(videoId, options) {
    var videoTracker = new VideoTracker;

    return videojs(videoId, options, function() {
        var error = this.error();

        if (error) {
            logError(this, error);

            return;
        }

        videoTracker.setup(this);

        this.on('play', function (event) {
            videoTracker.start();
        });

        this.on('pause', function (event) {
            videoTracker.stop();
        });

        this.on('dispose', function (event) {
            videoTracker.stop();
        });

        this.on('error', function (event) {
            var error = this.error();

            if (error) {
                logError(this, error);
            }

            videoTracker.stop();
        });

        if (this.tech_.hls && this.tech_.hls.xhr) {
            this.tech_.hls.xhr.beforeRequest = beforeRequest;
        }
    });
};

module.exports = init;
